import { FormConfig } from '@topdanmark-onlinesolutions/claim-form-types';

export const getElementFromElementId = (formConfig: FormConfig, elementId: string) => {
    const elements = formConfig.pages.flatMap((page) => page.elements);

    const targetElement = elements.find((element) => element.elementId === elementId);

    if (!targetElement) {
        throw new Error('Invalid elementId: ' + elementId);
    }

    return targetElement;
};
